import * as yup from 'yup';
import addValidation from './addValidation';

const updateUserValidationSchema = () => (yup.object({
  userName: addValidation('userName'),
  email: addValidation('email'),
  phoneNumber: addValidation('phoneNumber'),
  birthLastName: addValidation('birthLastName'),
  birthFirstName: addValidation('birthFirstName'),
  motherBirthLastName: addValidation('motherBirthLastName'),
  motherBirthFirstName: addValidation('motherBirthFirstName'),
  birthPlace: addValidation('birthPlace'),
  birthDate: addValidation('birthDate'),
  addressType: addValidation('addressType'),
}));

export default updateUserValidationSchema;
